import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, Subject } from 'rxjs';
import {
  BaseAuthenticatedService,
  httpQueryParams,
  PaginatedResponse,
  RecursiveInterface,
} from './base-authenticated.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@environments/environment';
import { switchMap } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { of } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { CorrispettiviReceiptsInterface } from '@app/interface/corrispettivi-receipts';

@Injectable({
  providedIn: 'root',
})
export class CorrispettiviReceiptsApi extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient,
    private route: ActivatedRoute, // Inject ActivatedRoute
  ) {
    super(auth, httpClient);
  }

  public getCorrispettiviReceiptsList<T = CorrispettiviReceiptsInterface>(
    organization_id: number | null,
    // projectId: number,
    params: httpQueryParams = {},
  ): Observable<PaginatedResponse<T>> {
    let path = `api/${organization_id}/corrispettivi-receipts/`;
    return this.getList<T>(path, params);
  }

  // using getRecursivePage
  public getAllCorrispettiviReceipts<T = CorrispettiviReceiptsInterface>(
    organization_id: number | null,
    params: httpQueryParams = {},
  ): Subject<RecursiveInterface<T>> {
    // console.log('id:', organization_id);

    const path = `api/${organization_id}/corrispettivi-receipts/`;
    return this.getRecursivePage<T>(path, params);
  }

  public createCorrispettiviReceipt(
    organization_id: number | null,
    invoiceData: Partial<CorrispettiviReceiptsInterface>,
  ): Observable<CorrispettiviReceiptsInterface> {
    // console.log('id:', organization_id);
    const path = `api/${organization_id}/corrispettivi-receipts/`;

    return this.post<CorrispettiviReceiptsInterface>(path, {}, invoiceData);
  }

  public updateCorrispettiviReceiptsDetails(
    organization_id: number | null,
    id: number,
    data: Partial<CorrispettiviReceiptsInterface>,
  ): Observable<CorrispettiviReceiptsInterface> {
    // console.log('data log.', data, 'id,', id);
    return this.partialUpdate<CorrispettiviReceiptsInterface>(
      `api/${organization_id}/corrispettivi-receipts/${id}/`,
      {}, //{ withCredentials: true },
      data,
    );
  }

  // public getMaxProgressiveNumber(
  //   organization_id: number | null,
  // ): Observable<number> {
  //   const path = `api/${organization_id}/invoice/max_progressive/`;
  //   return this.get<number>(path);
  // }
  public uploadCorrispettiviReceiptsXml(
    organization_id: number | null,
    xmlFile: File,
  ): Observable<any> {
    const formData = new FormData();
    formData.append('xml_file', xmlFile);

    const path = `api/${organization_id}/corrispettivi-receipts/upload-corrispettivi-xml/`;

    // Use getAuthHeaders with multipart/form-data - it will auto-remove Content-Type
    return this.getAuthHeaders({
      'Content-Type': 'multipart/form-data', // This will be removed by your base method
    }).pipe(
      switchMap((headers) => {
        return this.httpClient.post(
          `${environment.backendDomain}/${path}`,
          formData,
          {
            headers,
            reportProgress: true,
            observe: 'events',
          },
        );
      }),
    );
  }
}
